import { createStyles, Theme } from '@material-ui/core/styles';

import { radius } from '@shared/theme/shape';

import { OverlayType } from './Overlay';

export const styles = ({ breakpoints, spacing }: Theme) => {
  return createStyles({
    root: {},
    rootDisablePortal: {},

    scrollPaper: {
      // NOTE: Some styling is above
      overflowY: 'visible',
    },
    scrollPaperBackdropScroll: {
      overflowY: 'auto',
    },

    paper: {},
    paperLoading: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      minHeight: 200,
    },

    unsavedChangesModalRoot: {},
    unsavedChangesModalPaper: {},

    // Types
    [OverlayType.Drawer]: {
      '& > $scrollPaper': {
        alignItems: 'flex-start',
        justifyContent: 'flex-end',

        '& > $paper': {
          borderRadius: 0,
          height: '100%',
          margin: 0,
          maxHeight: '100%',
          overflowY: 'hidden',
          width: `100%`,
        },
      },
    },
    [OverlayType.FullScreen]: {
      '& > $scrollPaper': {
        alignItems: 'flex-start',
        justifyContent: 'flex-start',

        '& > $paper': {
          borderRadius: 0,
          height: '100%',
          margin: 0,
          maxHeight: '100%',
          overflowY: 'hidden',
          width: `100%`,
        },
      },
    },
    [OverlayType.Modal]: {
      // scrollPaper: For modals which are NOT rendered inside another overlay
      '&:not($rootDisablePortal) > $scrollPaper': {
        alignItems: 'flex-start',

        // paper: For modals which do not have backdrop scroll
        '&:not($scrollPaperBackdropScroll) > $paper': {
          maxHeight: `calc(100% - ${spacing(16) * 2}px)`,

          [breakpoints.down('lg')]: {
            maxHeight: `calc(100% - ${spacing(13) * 2}px)`,
          },

          [breakpoints.down('md')]: {
            maxHeight: `calc(100% - ${spacing(10) * 2}px)`,
          },

          [breakpoints.down('sm')]: {
            maxHeight: `calc(100% - ${spacing(7) * 2}px)`,
          },

          [breakpoints.down('xs')]: {
            maxHeight: `calc(100% - ${spacing(4) * 2}px)`,
          },
        },

        // paper: For all modals
        '& > $paper': {
          margin: spacing(16),

          [breakpoints.down('lg')]: {
            margin: spacing(13),
          },

          [breakpoints.down('md')]: {
            margin: spacing(10),
          },

          [breakpoints.down('sm')]: {
            margin: spacing(7),
          },

          [breakpoints.down('xs')]: {
            margin: spacing(4),
          },
        },
      },

      // scrollPaper: For modals which ARE rendered inside another overlay
      '&$rootDisablePortal > $scrollPaper': {
        alignItems: 'center',

        '& > $paper': {
          margin: spacing(4),
          maxHeight: `calc(100% - ${spacing(4) * 2}px)`,
        },
      },

      // scrollPaper: For all modals
      '& > $scrollPaper': {
        '& > $paper': {
          borderRadius: radius.tile,
          overflowY: 'hidden',
          width: `100%`,

          [breakpoints.down('xs')]: {
            minWidth: 'auto',
          },
        },
      },
    },
  });
};
